import React, { Component } from 'react'
import { connect } from 'react-redux'
import { openChangePasswordDialog, openSelfDefinedUserIdDialog, openApplySelfDefinedUserIdDialog } from '@/actions/app/dialog.action'

class CashAccount extends Component {
    render() {
        const { language ,username } = this.props
        return (
            <React.Fragment>
                {username ?
                    <div onClick={() => openSelfDefinedUserIdDialog()} className="label" style={{ cursor: 'pointer' }}>
                        {language.enquiry_self_defined_user_id}
                    </div> :
                    <div onClick={() => openApplySelfDefinedUserIdDialog()} className="label" style={{ cursor: 'pointer' }}>
                        {language.self_defined_user_id}</div>}
                <div onClick={() => openChangePasswordDialog()} className="label" style={{ cursor: 'pointer' }}>
                    {language.change_password_header}
                </div>
                <div className="label">
                    {language.place_order_dialog_cash_account}
                </div>
            </React.Fragment>
        )
    }
}

export default connect(state => ({
    language: state.app.language,
    username: state.auth.username
}))(CashAccount)
